<div [formGroup]="parentForm" [class.ms-xlarge-b]="displayMargin">
  <div class="relative ps-xxsmall-b">
    <label
      class="grey-600-text text-icon-secondary font-body-medium"
      [for]="idOrControlName"
      [class.block]="type === FormInputType.TEXTAREA"
    >
      {{ labelPrefix }}
      {{ translationPrefix + '.label' | finLocalization }}
      {{ labelSuffix }}
      @if (isRequired) {
        <span> *</span>
      }
    </label>
    @if (type === FormInputType.INPUT) {
      <input
        class="light-type font-body-medium"
        [class.form-field-empty]="!(control.value || placeHolder)"
        [class.sensitive]="isSensitive"
        type="text"
        [formControlName]="controlName"
        [id]="idOrControlName"
        [attr.placeholder]="placeHolder ? (placeHolder | finLocalization) : null"
        [attr.aria-required]="isRequired"
        [name]="controlName"
        #inputElement
      />
    }
    @if (parentForm.get(controlName)?.disabled === false) {
      <span class="divider"></span>
    }
    @if (type === FormInputType.TEXTAREA) {
      <textarea
        class="border grey-200-bg surface-disabled-bg fill ps-xsmall ms-small-t font-body-medium"
        [class.sensitive]="isSensitive"
        [class.resizeable]="isResizeable"
        type="text"
        [formControlName]="controlName"
        [id]="idOrControlName"
        [rows]="rows"
        #textareaElement
      ></textarea>
    }
  </div>
  @if (control.invalid && control.touched) {
    <div
      class="error-label error-900-text signal-error-notification-border-icon-text light-type font-body-small"
      aria-live="polite"
    >
      @if (control.errors?.required) {
        <p>{{ translationPrefix + '.required' | finLocalization }}</p>
      }
      @if (control.errors?.pattern) {
        <p>{{ translationPrefix + '.pattern' | finLocalization }}</p>
      }
      @if (control.errors?.duplicate) {
        <p>{{ translationPrefix + '.duplicate' | finLocalization }}</p>
      }
      @if (control.errors?.maxlength) {
        <p>
          {{
            translationPrefix + '.maxLength'
              | finLocalization: { requiredLength: control.errors.maxlength.requiredLength }
          }}
        </p>
      }
      @if (control.errors?.minlength) {
        <p>
          {{
            translationPrefix + '.minLength'
              | finLocalization: { requiredLength: control.errors.minlength.requiredLength }
          }}
        </p>
      }
    </div>
  }
  @if (characterLimit && characterCount) {
    <div
      class="nordic-blue-900-text text-icon-primary font-body-medium"
      [attr.data-testid]="'character-limit-for-' + controlName"
    >
      {{ characterCount }} / {{ characterLimit }}
    </div>
  }
</div>
